import { numberIsBetween } from '@@viewHelpers/validations/index.js';

// spouseAverageAge et childrenAverageAge n'ont pas encore de champ dans le formulaire
export const DEMOGRAPHY_BOUNDS = {
  employeeCount: {
    prefix: 'ENTREPRISE_DEMOGRAPHIE_NB_SALARIES',
    minVar: 'minEmployeeQuantity',
    maxVar: 'maxEmployeeQuantity'
  },
  partnerCount: {
    prefix: 'ENTREPRISE_DEMOGRAPHIE_NB_CONJOINTS',
    minVar: 'minSpouseQuantity',
    maxVar: 'maxSpouseQuantity'
  },
  childrenCount: {
    prefix: 'ENTREPRISE_DEMOGRAPHIE_NB_ENFANTS',
    minVar: 'minChildrenQuantity',
    maxVar: 'maxChildrenQuantity'
  },
  employeeAverageAge: {
    prefix: 'ENTREPRISE_DEMOGRAPHIE_AGE_MOYEN_SALARIE',
    minVar: 'minEmployeeAverageAge',
    maxVar: 'maxEmployeeAverageAge'
  },
  spouseAverageAge: {
    prefix: 'ENTREPRISE_DEMOGRAPHIE_AGE_MOYEN_CONJOINT',
    minVar: 'minSpouseAverageAge',
    maxVar: 'maxSpouseAverageAge'
  },
  childrenAverageAge: {
    prefix: 'ENTREPRISE_DEMOGRAPHIE_AGE_MOYEN_ENFANT',
    minVar: 'minChildrenAverageAge',
    maxVar: 'maxChildrenAverageAge'
  }
};

export const getBounds = (getMiddleNumber, getMiddleText) => (field) => {
  const { prefix, minVar, maxVar } = DEMOGRAPHY_BOUNDS[field];
  const min = getMiddleNumber(`${prefix}_MIN`);
  const max = getMiddleNumber(`${prefix}_MAX`);

  return {
    min,
    max,
    info: getMiddleText(`${prefix}_INFO`, { [minVar]: min, [maxVar]: max })
  };
};

export const buildBoundsRules = (getMiddleNumber, getMiddleText) => {
  const boundsOf = getBounds(getMiddleNumber, getMiddleText);

  return (field, mandatory) => {
    const { min, max, info } = boundsOf(field);
    return numberIsBetween(min, max, info, mandatory);
  };
};
